import {
  WSAvatar,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSLoader,
  WSPanel,
  WSText,
  toWSMoneyString
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { useQueryPaidInvoices } from "../../query/payments/queries";
import { getInvoices } from "../../query/payments/selectors";
import { selectorIsInvoicePaidNotDeposited } from "../selectors/selectorIsInvoicePaidNotDeposited";
import { calculateInvoicesTotal } from "../utils";

type Props = {
  dateRange: [Date, Date] | null;
};

export const SummaryPaid: React.FC<Props> = ({ dateRange }) => {
  const history = useHistory();

  const queryPaidInvoices = useQueryPaidInvoices();
  const paidInvoices = getInvoices(
    queryPaidInvoices.data || []
  ).filter(invoice =>
    dateRange && invoice.events.openedAt
      ? dateRange[0] < invoice.events.openedAt &&
        invoice.events.openedAt < dateRange[1]
      : true
  );

  const pendingInvoices = paidInvoices.filter(
    selectorIsInvoicePaidNotDeposited
  );

  return (
    <WSPanel
      onClick={
        paidInvoices.length > 0
          ? () => {
              history.push("/member/invoices/paid");
            }
          : undefined
      }
    >
      <WSFlexBox.CenterY justify="space-between" wrap="nowrap">
        <WSAvatar.Icon
          size="L"
          icon="check-double"
          color="green500"
          colorBackground="green50"
          mr="XL"
        />
        <WSElement style={{ flex: 1 }}>
          {queryPaidInvoices.isLoading ? (
            <WSLoader.Spinner />
          ) : (
            <>
              <WSText.Heading5 color="green500" mb="XS">
                +{toWSMoneyString(calculateInvoicesTotal(paidInvoices))}
              </WSText.Heading5>
              <WSText color="gray600">
                paid
                {pendingInvoices.length > 0 && (
                  <>
                    {" "}
                    <WSText inline>
                      (
                      {toWSMoneyString(calculateInvoicesTotal(pendingInvoices))}{" "}
                      pending)
                    </WSText>
                  </>
                )}
              </WSText>
            </>
          )}
        </WSElement>
        {paidInvoices.length > 0 && (
          <WSIcon block name="chevron-right" color="blue400" size="S" />
        )}
      </WSFlexBox.CenterY>
    </WSPanel>
  );
};
